import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import MenuPage from './Components/MenuGenerator/MenuPage';
import LoginPage from './Components/LoginPage';
import DishesPage from './Components/Dishes/DishesPage';
import ChangeDishPages from './Components/Dishes/Popups/Dish/ChangeDishPages';
import CreateIngredient from './Components/Dishes/Popups/Dish/Products/CreateProduct';
import ControlUsers from './Components/Menus/ControlUsers';
import TemplatesPage from './Components/Templates/TemplatesPage';
import LogInRoute from './Components/Common/LogInRoute';
import TagsPage from './Components/Tags/TagsPage';
import TemplateGenerator from './Components/TemplateGenerator';
import Navbar from './Components/Common/Navbar';
import LoaderPopup from './Components/Common/LoaderPopup';
import RecipeModal from './Components/Common/RecipeModal';
import CreateProductPage from './Components/YouSlim2.0/CreateProductPage';
import CreateDishPage from './Components/YouSlim2.0/CreateDishPage';
import ProductsListPage from './Components/YouSlim2.0/ProductsListPage';
import SubTemplateTrainingVideos from './Components/Training/TrainingList/SubTemplateTrainingVideos';
import TrainingVideos from './Components/Training/TrainingList/TrainingVideos';
import TemplateTrainingVideos from './Components/Training/TrainingList/TemplateTrainingVideos';
import ChangeTemplateVideos from './Components/Training/ChangingTarainingList/ChangeTemplateVideos';
import ChangeTrainingVideos from './Components/Training/ChangingTarainingList/ChangeTrainingVideos';
import ChangeSubtemplateVideos from './Components/Training/ChangingTarainingList/ChangeSubtemplateVideos';
import MotivationVideos from './Components/Motivation/MotivationList/MotivationVideos';
import ChangeMotivationVideos from './Components/Motivation/ChangeMotivationList/ChangeMotivationVideos';
import DishListPage from './Components/YouSlim2.0/DishListPage';
import UserPage from './Components/YouSlim2.0/UserPage';
import CreateTraining from './Components/YouSlim2.0/CreateTraining';
import CreateTrainingList from './Components/YouSlim2.0/CreateTrainingList';
import CreateTrainingTemplate from './Components/YouSlim2.0/CreateTrainingTemplate';
import ClientList from './Components/YouSlim2.0/ClientList';
import NutritionCourse from './Components/YouSlim2.0/NutritionCourse';
import TrainingCourse from './Components/YouSlim2.0/TrainingCourse';
import MarathonPage from './Components/YouSlim2.0/MarathonPage';

import TestPage from './Components/YouSlim2.0/TestPage';

const Routes = ({ cookies, logedIn }) => {
  const checkedLoggedIn = true;

  return (
    <Router>
      <PageContent>
        <Navbar />
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <LogInRoute exact path="/" logedIn={checkedLoggedIn} component={MenuPage} />
          <LogInRoute
            exact
            path="/subtemplateVideos"
            logedIn={checkedLoggedIn}
            component={SubTemplateTrainingVideos}
          />
          <LogInRoute
            exact
            path="/trainingVideos"
            logedIn={checkedLoggedIn}
            component={TrainingVideos}
          />
          <LogInRoute
            exact
            path="/templateVideos"
            logedIn={checkedLoggedIn}
            component={TemplateTrainingVideos}
          />
          <LogInRoute
            exact
            path="/changeTemplateVideos"
            logedIn={checkedLoggedIn}
            component={ChangeTemplateVideos}
          />
          <LogInRoute
            exact
            path="/changeTrainingVideos"
            logedIn={checkedLoggedIn}
            component={ChangeTrainingVideos}
          />
          <LogInRoute
            exact
            path="/changeSubtemplateVideos"
            logedIn={checkedLoggedIn}
            component={ChangeSubtemplateVideos}
          />
          <LogInRoute
            exact
            path="/motivationVideos"
            logedIn={checkedLoggedIn}
            component={MotivationVideos}
          />
          <LogInRoute
            exact
            path="/changeMotivationVideos"
            logedIn={checkedLoggedIn}
            component={ChangeMotivationVideos}
          />
          <LogInRoute exact path="/dishes" logedIn={checkedLoggedIn} component={DishesPage} />
          <LogInRoute
            exact
            path="/dish/:id/edit"
            logedIn={checkedLoggedIn}
            component={ChangeDishPages}
          />
          <LogInRoute
            exact
            path="/dish/create"
            logedIn={checkedLoggedIn}
            component={ChangeDishPages}
          />
          <LogInRoute
            exact
            path="/controlUsers"
            logedIn={checkedLoggedIn}
            component={ControlUsers}
          />
          <LogInRoute exact path="/templates" logedIn={checkedLoggedIn} component={TemplatesPage} />
          <LogInRoute
            exact
            path="/templateGenerator"
            logedIn={checkedLoggedIn}
            component={TemplateGenerator}
          />
          <LogInRoute
            exact
            path="/templateGenerator/:id"
            logedIn={checkedLoggedIn}
            component={TemplateGenerator}
          />

          <LogInRoute exact path="/tags" logedIn={checkedLoggedIn} component={TagsPage} />
          <LogInRoute
            exact
            path="/сreateIngredient"
            logedIn={checkedLoggedIn}
            component={CreateIngredient}
          />
        </Switch>
        <LoaderPopup />
        <RecipeModal />
      </PageContent>

      <LogInRoute
        path="/youslim2.0/product/:id/edit"
        logedIn={checkedLoggedIn}
        component={CreateProductPage}
      />
      <LogInRoute
        path="/youslim2.0/product/create"
        logedIn={checkedLoggedIn}
        component={CreateProductPage}
      />
      <LogInRoute
        path="/youslim2.0/dish/:id/edit"
        logedIn={checkedLoggedIn}
        component={CreateDishPage}
      />
      <LogInRoute
        path="/youslim2.0/dish/create"
        logedIn={checkedLoggedIn}
        component={CreateDishPage}
      />
      <LogInRoute
        path="/youslim2.0/productsList"
        logedIn={checkedLoggedIn}
        component={ProductsListPage}
      />

      <LogInRoute
        path="/youslim2.0/userPage/:id/change"
        logedIn={checkedLoggedIn}
        component={UserPage}
      />
      <LogInRoute path="/youslim2.0/userPage/view" logedIn={checkedLoggedIn} component={UserPage} />
      <LogInRoute path="/youslim2.0/dishList" logedIn={checkedLoggedIn} component={DishListPage} />
      <LogInRoute
        path="/youslim2.0/createTraining/create"
        logedIn={checkedLoggedIn}
        component={CreateTraining}
      />
      <LogInRoute
        path="/youslim2.0/createTraining/:id/edit"
        logedIn={checkedLoggedIn}
        component={CreateTraining}
      />
      <LogInRoute
        path="/youslim2.0/createTrainingList/create"
        logedIn={checkedLoggedIn}
        component={CreateTrainingList}
      />
      <LogInRoute
        path="/youslim2.0/createTrainingTemplate/create"
        logedIn={checkedLoggedIn}
        component={CreateTrainingTemplate}
      />
      <LogInRoute path="/youslim2.0/clientList" logedIn={checkedLoggedIn} component={ClientList} />
      <LogInRoute
        path="/youslim2.0/nutritionCourse/:user/:id/:courseId"
        logedIn={checkedLoggedIn}
        component={NutritionCourse}
      />

      <LogInRoute path="/youslim2.0/testPage" logedIn={checkedLoggedIn} component={TestPage} />
      <LogInRoute
        path="/youslim2.0/trainingCourse/:user/:id/:courseId"
        logedIn={checkedLoggedIn}
        component={TrainingCourse}
      />
       <LogInRoute
        path="/youslim2.0/marathonPage"
        logedIn={checkedLoggedIn}
        component={MarathonPage}
      />
    </Router>
  );
};

const mapStateToProps = (state) => {
  const { logedIn } = state.login;
  return {
    logedIn,
  };
};

export default connect(mapStateToProps)(Routes);

const PageContent = styled.div`
  width: 100%;
  padding-bottom: 50px;
`;



// WEBPACK FOOTER //
// ./src/Routes.jsx